import { createSlice } from "@reduxjs/toolkit";
import {
  viewNews,
  singleNews,
  registerNews,
  updateNews,
  deleteNews,
} from "../actions/newsAction";

const newsSlice = createSlice({
  name: "News",
  initialState: {
    News: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateNews.fulfilled, (state, action) => {
        state.loading = false;
        state.News = action.payload;
      })
      .addCase(updateNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteNews.fulfilled, (state, action) => {
        state.loading = false;
        state.News = action.payload;
      })
      .addCase(deleteNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleNews.fulfilled, (state, action) => {
        state.loading = false;
        state.News = action.payload;
      })
      .addCase(singleNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerNews.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.News = action.payload;
      })
      .addCase(registerNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewNews.fulfilled, (state, action) => {
        state.loading = false;
        state.News = action.payload;
      })
      .addCase(viewNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
